import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import FooterImageRectangleBlock, {
    ImageRectangle,
} from '@/_application/themes/kidsplaza-spring/layouts/components/footer/kidsplaza-spring.desktop.image-rectangle-block';
import {Routes} from '@/config/routes';
import CompanyInfo from './kidsplaza-spring.desktop.company-info';
import ContactUsBlock from './kidsplaza-spring.desktop.contact-us-block';
import FooterSubscriptionForm from './kidsplaza-spring.desktop.footer-subscription-form';
import NavigationFooter, {PathFooter} from './kidsplaza-spring.desktop.navigation-footer';
import QualityCertificationBlock from './kidsplaza-spring.desktop.quality-certification-block';
import {useEffect, useState} from 'react';

const downloadAppBannerFooter = getImageAssetUrl('images/download-app-banner-footer.png');

const mainPaths: PathFooter[] = [
    {title: 'Giới thiệu KidsPlaza', key: Routes.aboutUs},
    {title: 'Danh sách cửa hàng', key: Routes.storeSystem},
    {title: 'Báo chí nói về chúng tôi', key: 'blog/tin-ve-kids-plaza/bao-chi-noi-ve-chung-toi'},
    {title: 'Kiến thức nuôi con', key: Routes.blog},
    {title: 'Tuyển dụng', key: 'https://tuyendung.kidsplaza.vn/'},
    {title: 'Chính sách bảo mật', key: Routes.privacyPolicy},
    {title: 'Chính sách Kicoin', key: Routes.memberIncentives},
];

const customerSupportPaths: PathFooter[] = [
    {title: 'Quy định đổi trả hàng', key: Routes.returnRegulations},
    {title: 'Phương thức thanh toán', key: Routes.paymentMethod},
    {title: 'Phương thức giao hàng', key: Routes.deliveryMethod},
    {title: 'Lớp học tiền sản miễn phí', key: 'https://hoithaotiensan.com/'},
    {title: 'Lớp học ăn dặm miễn phí', key: 'https://lopandam.kidsplaza.vn/'},
    {title: 'Gửi góp ý / Khiếu nại', key: Routes.contact},
    {title: 'Chính sách bảo hành', key: Routes.warrantyPolicy},
    {title: 'Câu hỏi thường gặp', key: Routes.questionAndAnswer},
    {title: 'Hướng dẫn thanh toán VNPAY', key: Routes.vnpayGuide},
];

const PaymentMethods: ImageRectangle[] = [
    {src: getImageAssetUrl('images/visa-rectangle-icon.png'), alt: 'visa-rectangle-icon'},
    {src: getImageAssetUrl('images/master-card-rectangle-icon.png'), alt: 'master-card-rectangle-icon'},
    {src: getImageAssetUrl('images/cash-rectangle-icon.png'), alt: 'cash-rectangle-icon'},
    {src: getImageAssetUrl('images/JCB-rectangle-icon.png'), alt: 'JCB-rectangle-icon'},
    {src: getImageAssetUrl('images/momo-rectangle-icon.png'), alt: 'momo-rectangle-icon'},
    {src: getImageAssetUrl('images/banking-icon.png'), alt: 'banking-icon'},
    {src: getImageAssetUrl('images/cod-icon.png'), alt: 'cod-icon'},
    {src: getImageAssetUrl('images/vn-pay-icon.png'), alt: 'vn-pay-icon'},
    {src: getImageAssetUrl('images/zalo-pay-icon.png'), alt: 'zalo-pay-icon'},
    {src: getImageAssetUrl('images/shopee-pay-icon.png'), alt: 'shopee-pay-icon'},
];

const ShippingMethods: ImageRectangle[] = [
    {src: getImageAssetUrl('images/ghtk-rectangle-icon.png'), alt: 'ghtk-rectangle-icon'},
    {src: getImageAssetUrl('images/ghn-rectangle-icon.png'), alt: 'ghn-rectangle-icon'},
    {src: getImageAssetUrl('images/ahamove-rectangle-icon.png'), alt: 'ahamove-rectangle-icon'},
];

function Footer() {
    const [hasScrolledOrClicked, setHasScrolledOrClicked] = useState(false);

    useEffect(() => {
        const handleScrollOrClick = () => {
            setHasScrolledOrClicked(true);
        };

        window.addEventListener('scroll', handleScrollOrClick);
        globalThis.addEventListener('click', handleScrollOrClick);

        return () => {
            window.removeEventListener('scroll', handleScrollOrClick);
            globalThis.removeEventListener('click', handleScrollOrClick);
        };
    }, []);

    return (
        hasScrolledOrClicked && (
            <footer className="bg-secondary">
                <Link href={Routes.appDownload}>
                    <Image
                        priority={true}
                        src={downloadAppBannerFooter}
                        alt="Banner"
                        width={1512}
                        height={250}
                        className="mb-5 w-full cursor-pointer transition-opacity hover:opacity-90"
                    />
                </Link>
                <div className="w-full bg-white">
                    <div className="mx-auto max-w-299 px-5 pb-7 pt-8 lg:px-3 ">
                        <div className="mb-10 grid grid-cols-12 gap-4 lg:mb-8">
                            <div className="col-span-6 lg:col-span-4">
                                <CompanyInfo />
                            </div>

                            <div className="col-span-3 mt-8 lg:col-span-2">
                                <NavigationFooter title="Về Kidsplaza" paths={mainPaths} />
                            </div>
                            <div className="col-span-3 mt-8 lg:col-span-2">
                                <NavigationFooter title="Hỗ trợ khách hàng" paths={customerSupportPaths} />
                            </div>

                            <div className="col-span-12 mt-8 flex flex-col gap-10 lg:col-span-4">
                                <div className="">
                                    <FooterSubscriptionForm />
                                </div>

                                <div className="flex items-start gap-5">
                                    <div className="flex-1">
                                        <FooterImageRectangleBlock
                                            title="Phương thức thanh toán"
                                            items={PaymentMethods}
                                        />
                                    </div>

                                    <div className="flex-1 lg:hidden">
                                        <FooterImageRectangleBlock
                                            title="Hình thức vận chuyển"
                                            items={ShippingMethods}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-6 lg:col-span-4">
                                <ContactUsBlock />
                            </div>

                            <div className="col-span-6 lg:col-span-3">
                                <QualityCertificationBlock />
                            </div>

                            <div className="lg:col-span-1"></div>

                            <div className="hidden lg:col-span-4 lg:block">
                                <FooterImageRectangleBlock title="Hình thức vận chuyển" items={ShippingMethods} />
                            </div>
                        </div>
                    </div>

                    <div className="mx-auto max-w-299 pb-5.5">
                        <p className="px-5 text-xs text-black lg:px-3">
                            Bản quyền © 2024 Kids Plaza - Hệ thống cửa hàng Mẹ Bầu và Em Bé Kids Plaza.
                        </p>
                    </div>
                </div>
            </footer>
        )
    );
}

export default Footer;
